import AirlineFilterShimmer from '@/src/components/mobile/srp/loadingShimmers/airlineFilterShimmer'
import DateCarouselShimmer from '@/src/components/mobile/srp/loadingShimmers/dateCarouselShimmer'
import SortTabsShimmer from '@/src/components/mobile/srp/loadingShimmers/sortTabsShimmer'
import { DESKTOP } from '@/src/constants/deviceTypes'
import { Box, Container, Skeleton } from '@mui/material'
import React from 'react'
import DesktopCouponSectionShimmer from './DesktopCouponSectionShimmer'
import DesktopFiltersShimmer from './DesktopFiltersShimmer'
import DesktopFlightCardShimmer from './DesktopFlightCardShimmer'
import SrpTipBannerWrapper from '@/src/components/desktop/srp/srpTipBanner'

const DesktopSrpLoadingShimmer: React.FC = () => (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, lg: 4 }, py: 1 }}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '280px 1fr',
                    gap: { xs: 3, lg: 4 },
                    alignItems: 'start'
                }}
            >
                {/* Sidebar Filters Shimmer */}
                <DesktopFiltersShimmer />

                {/* Main Content Shimmer */}
                <Box>
                    <SrpTipBannerWrapper />
                    <DesktopCouponSectionShimmer />
                    <SortTabsShimmer />
                    <AirlineFilterShimmer deviceType={DESKTOP} />
                    <Box sx={{ mt: 2, p: 2, border: '1px solid', borderColor: 'grey.200', borderRadius: 1 }}>
                        <Box sx={{ borderBottom: '1px solid', borderColor: 'grey.200', pb: 2 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 2 }}>
                                <Skeleton variant="text" width={120} height={32} />
                                <Skeleton variant="text" width={80} height={32} />
                            </Box>
                        </Box>
                        <DateCarouselShimmer deviceType={DESKTOP} />
                        <Box sx={{ mt: 2, p: 2 }}>
                            {[...Array(5)].map((_, i) => (
                                <DesktopFlightCardShimmer key={i} />
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Container>
    </Box>
)

export default DesktopSrpLoadingShimmer
